/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

import {IAM_BASE_URL} from './applicationContext';
import StompClient, {CLIENT_IDENTIFIER_IAM} from './services/Stomp/StompClient';
import LocalStorage from './services/LocalStorage/LocalStorage';
import LoginService from './services/LoginService/LoginService';
import RememberMeAuthenticationResource from './services/IamApi/RememberMeAuthenticationResource';
import TwoFactorAuthenticationResource from './services/IamApi/TwoFactorAuthenticationResource';
import PhoneNumberLookupResource from './services/IamApi/PhoneNumberLookupResource';
import PasswordStrengthResource from './services/IamApi/PasswordStrengthResource';
import FlexServiceWorkerRegistrationResource from './services/IamApi/FlexServiceWorkerRegistrationResource';
import EmployeeRegistrationResource from './services/IamApi/EmployeeRegistrationResource';
import AccountRecoveryResource from './services/IamApi/AccountRecoveryResource';
import AccountEmailChangeResource from './services/IamApi/AccountEmailChangeResource';
import ApiClientsConfigurer from './services/ApiClientsConfigurer';

ApiClientsConfigurer.configureApiClients();
export const accountEmailChangeResource: AccountEmailChangeResource = new AccountEmailChangeResource();
export const accountRecoveryResource: AccountRecoveryResource = new AccountRecoveryResource();
export const employeeRegistrationResource: EmployeeRegistrationResource = new EmployeeRegistrationResource();
export const flexServiceWorkerRegistrationResource: FlexServiceWorkerRegistrationResource = new FlexServiceWorkerRegistrationResource();
export const passwordStrengthResource: PasswordStrengthResource = new PasswordStrengthResource();
export const phoneNumberLookupResource: PhoneNumberLookupResource = new PhoneNumberLookupResource();
export const rememberMeAuthenticationResource: RememberMeAuthenticationResource = new RememberMeAuthenticationResource();
export const twoFactorAuthenticationResource: TwoFactorAuthenticationResource = new TwoFactorAuthenticationResource();

export const iamStompClient: StompClient = new StompClient(CLIENT_IDENTIFIER_IAM, IAM_BASE_URL);

export const localStorage = new LocalStorage();

export const loginService = new LoginService();
